import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface AuthUser {
  id: string;
  email: string;
  role: string;
  name: string;
  jiraPersonalToken: string | null;
  jiraEmail: string | null;
}

export function useAuth() {
  const qc = useQueryClient();

  const { data: user, isLoading } = useQuery<AuthUser | null>({
    queryKey: ['auth/me'],
    queryFn: async () => {
      try {
        return await api.getMe();
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60_000,
    retry: false,
  });

  const logout = () => {
    // POST via a form so the browser sends the session cookie correctly,
    // then hard-navigate to clear React state.
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/auth/logout';
    document.body.appendChild(form);
    form.submit();
  };

  return {
    user: user ?? null,
    isLoading,
    isAuthenticated: !!user,
    logout,
  };
}
